import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type TriggerFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const TriggerFilled = ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }: TriggerFilledProps) =>
  h(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      fill: color,
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      color,
      "stroke-width": strokeWidth,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'translate(-2.753867 -3.456044) scale(1.209431)',
        },
        [
          h(
            'path',
            {
              d: 'M12.199 3.271C6.94668 3.271 2.69043 7.52725 2.69043 12.7796C2.69043 18.0319 6.94668 22.2882 12.199 22.2882C17.4514 22.2882 21.7076 18.0319 21.7076 12.7796C21.7076 7.52725 17.449 3.271 12.199 3.271ZM11.5143 7.74166C11.5143 7.54244 11.5846 7.37135 11.7252 7.22604C11.8658 7.08072 12.0369 7.00807 12.2338 7.00807C12.44 7.00807 12.6135 7.08072 12.7541 7.22604C12.8947 7.37135 12.965 7.54244 12.965 7.74166V12.0917C12.965 12.2909 12.8947 12.4596 12.7541 12.6003C12.6135 12.7409 12.44 12.8112 12.2338 12.8112C12.0346 12.8112 11.8658 12.7409 11.7252 12.6003C11.5846 12.4596 11.5143 12.2885 11.5143 12.0917V7.74166ZM16.9588 14.7776C16.6869 15.3987 16.3213 15.9424 15.8596 16.4042C15.3979 16.8659 14.8565 17.2315 14.233 17.5034C13.6119 17.7753 12.9439 17.9088 12.2361 17.9088C11.533 17.9088 10.8721 17.7729 10.2486 17.5034C9.62754 17.2315 9.08379 16.8659 8.61739 16.4042C8.15098 15.9424 7.78536 15.401 7.51817 14.7776C7.25098 14.1565 7.11739 13.4885 7.11739 12.7807C7.11739 12.3753 7.16426 11.9792 7.26036 11.5901C7.35645 11.201 7.49004 10.8307 7.66583 10.4792C7.84161 10.1276 8.05958 9.79947 8.31739 9.49479C8.92208 8.78697 9.53614 8.50338 9.73067 8.53385C9.9252 8.56432 10.0846 8.66041 10.2065 8.81979C10.3283 8.97916 10.3752 9.15963 10.3447 9.35885C10.3143 9.55807 10.2182 9.71744 10.0588 9.83932C9.57833 10.1909 9.21036 10.6221 8.95489 11.1331C8.69942 11.644 8.57051 12.1948 8.57051 12.7807C8.57051 13.2846 8.66661 13.7604 8.85645 14.2057C9.04629 14.651 9.30879 15.0424 9.64161 15.3729C9.97442 15.7057 10.3635 15.9682 10.8088 16.1628C11.2565 16.3573 11.7299 16.4557 12.2338 16.4557C12.7377 16.4557 13.2135 16.3596 13.6588 16.1628C14.1065 15.9682 14.4955 15.7057 14.826 15.3729C15.1588 15.0401 15.4213 14.651 15.6158 14.2057C15.8104 13.7604 15.9088 13.2846 15.9088 12.7807C15.9088 12.1854 15.7705 11.6229 15.4963 11.0909C15.2221 10.5612 14.8354 10.1229 14.3408 9.78073C14.1721 9.66588 14.0713 9.50885 14.0361 9.31198C14.001 9.11276 14.0408 8.92994 14.1557 8.76119C14.2705 8.60182 14.4275 8.50338 14.6244 8.46823C14.8236 8.43307 15.0064 8.47291 15.1752 8.58776C15.5174 8.83151 15.8244 9.10807 16.0916 9.41744C16.3588 9.72682 16.5885 10.0596 16.7783 10.4182C16.9682 10.7768 17.1135 11.1565 17.2143 11.5573C17.308 11.9229 17.3643 12.3424 17.3643 12.7737V12.776C17.3643 13.4909 17.2283 14.1565 16.9588 14.7776Z',
            },
          ),
        ],
      ),
    ],
  );

export default TriggerFilled;
